import React from "react";
import "./FeatureCard.scss";

const FeatureCard = ({ fImg, title, description, buttonText }) => {
  return (
    <div
      className="services-card"
      style={{
        height: "90%",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
        padding: "30px",
      }}
    >
      <div className="icon" style={{ marginBottom: "30px" }}>
        <img src={fImg} alt="" />
      </div>
      <h2
        style={{
          fontSize: "22px",
          lineHeight: "1.3",
          marginBottom: "25px",
          color: "#333",
        }}
      >
        {title}
      </h2>
      <span style={{ display: "block", color: "#525252" }}>{description}</span>
    </div>
  );
};

export default FeatureCard;
